import { OrderedItem } from '../interfaces';

/** Collect unique discount IDs applied on order items and modifiers. */
export function getAppliedDiscountIds(
  items: Array<Pick<OrderedItem, 'discounts' | 'modifiers'>> | null | undefined
): string[] {
  const ids = new Set<string>();
  (items || []).forEach(item => {
    (item.discounts || []).forEach(discount => {
      if (discount?.id) {
        ids.add(String(discount.id));
      }
    });
    (item.modifiers || []).forEach(modifier => {
      (modifier.discounts || []).forEach(discount => {
        if (discount?.id) {
          ids.add(String(discount.id));
        }
      });
    });
  });
  return Array.from(ids);
}
